import * as React from 'react';
import { cn } from '../../lib/utils';

export type ContainerProps = React.HTMLAttributes<HTMLDivElement>;

const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, children, ...props }, ref) => (
    <div ref={ref} className={cn('mx-auto w-11/12 max-w-screen-lg', className)} {...props}>
      {children}
    </div>
  )
);
Container.displayName = 'Container';

export { Container };
